import { PathItem } from './types';

const paths: PathItem[] = [
  { key: 'admin', path: 'auth/password/reset' },
  { key: 'end-user', path: 'admin/ldap/user/end-user-reset-password' },
];

export const getPath = (type: string): string => paths.find(({ key }) => key === type)?.path || '';
